import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "src/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance };
